interface FileUploadData {
  file: File | null;
  characterCode: string;
}

/**
 * ファイルマップからFormDataを構築する共通関数
 * @param fileMap - フォームデータに含めるファイルのマップ（キーはフォームデータのフィールド名、値はFileUploadData）
 * @returns FormData - 構築されたFormData
 */
function buildFileFormData(fileMap: Map<string, FileUploadData>) {
  const formData = new FormData();
  fileMap.forEach(({ file, characterCode }, formKey) => {
    if (file) {
      formData.append(
        formKey,
        new File([file], file.name, {
          type: `${file.type}; charset=${characterCode}`,
        }),
      );
    }
  });
  return formData;
}

export type { FileUploadData };
export { buildFileFormData };
